import React from 'react';
import './ProjectCategoryCard.css';

const ProjectCategoryCard = ({ categories = [] }) => {
  return (
    <section className="project-category-section">
      <div className="dynamic-container">
        <div className="project-category-grid">
          {categories.map((category, index) => (
            <div key={index} className="project-category-card">
              <div className="category-header">
                <h4 className="category-title">{category.title}</h4>
              </div>
              
              {category.examples && category.examples.length > 0 && (
                <div className="category-examples">
                  <p className="category-label">例：</p>
                  <ul className="examples-list">
                    {category.examples.map((example, idx) => (
                      <li key={idx}>{example}</li>
                    ))}
                  </ul>
                </div>
              )}
              
              {category.features && category.features.length > 0 && (
                <div className="category-features">
                  <p className="category-label">特徴：</p>
                  <ul className="features-list">
                    {category.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectCategoryCard;
